import { useEffect } from "react";
import "./Info.scss"

export default function Cbu() {
  useEffect(()=>{
      window.scrollTo(0, 0);
    },[])
  return (
    <div className="info-pages cbu">
      <div className="info-header"></div>
      <div className="page-info-content">
        <div className="page-info-header">
          <div className="title">Datos Bancarios</div>
        </div>
        <div className="page-info-data">
          <img loading="lazy" src="https://www.didacticosdelsur.com/assets/images/santander.png" alt="Santander"></img>
          <ul>
            <li>Número de Cuenta: CC en Pesos 135-018075/3</li>
            <li>Número de CBU: 0720135220000001807536</li>
            <li>Alias: TOLDO.DAMA.PAPEL</li>
            <li>Razón Social: CIUDADES DEL SUR SA</li>
            <li>CUIT/CUIL: 30708953195</li>
          </ul>
        </div>
      </div>
    </div>
  )
}